import { useAuth } from '../context/AuthContext';
import { useQuery } from '@apollo/client';
import { MEUS_LOCAIS } from '../services/quadraAdminService';

type UserObj = { atleta?: { id?: string }; role?: string; id?: string; nome?: string } | null;

const getUser = (authUser: unknown): UserObj => {
  if (authUser) return authUser as UserObj;
  try { return JSON.parse(localStorage.getItem('user') ?? 'null'); } catch { return null; }
};

export const useUserRole = () => {
  const auth = useAuth();
  const user = getUser(auth?.user);
  const isAdmin = user?.role === 'ADMIN';

  const { data } = useQuery(MEUS_LOCAIS, {
    skip: isAdmin || !user?.id,
    fetchPolicy: 'cache-first',
    errorPolicy: 'ignore',
  });

  const isAdminLocal = isAdmin || (data?.meusLocais?.length ?? 0) > 0;

  return {
    isAdmin,
    isAdminLocal,
    isAtleta: !!user?.atleta?.id,
    atletaId: user?.atleta?.id ?? '',
    userId: user?.id ?? '',
    userName: user?.nome ?? '',
  };
};
